import { Snowflake, Gift } from "lucide-react";
import { scrollToId } from "../lib/smooth";
import { ChristmasCountdown } from "./ChristmasCountdown";
import { ChristmasCutoffs } from "./ChristmasCutoffs";

const flakes = [
  ["top-6 left-[8%]", "w-6 h-6", "0s"], ["top-16 right-[12%]", "w-8 h-8", "1.2s"],
  ["bottom-10 left-[20%]", "w-5 h-5", "0.6s"], ["bottom-6 right-[28%]", "w-7 h-7", "1.8s"],
];

export const ChristmasSoon = () => (
  <div data-testid="christmas-coming-soon"
    className="relative overflow-hidden rounded-[28px] chunk bg-[#c8102e] text-white px-6 py-14 sm:px-12 sm:py-20 text-center">
    {flakes.map(([pos, size, delay]) => (
      <Snowflake key={pos} className={`absolute ${pos} ${size} text-white/40 animate-pulse`} style={{ animationDelay: delay }} />
    ))}
    <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#1e7a46] border-2 border-[var(--ink)] font-mono-x text-xs uppercase tracking-[0.2em] font-bold">
      <Gift className="w-4 h-4" /> Christmas prints
    </span>
    <p className="font-display font-extrabold tracking-tighter text-5xl sm:text-7xl lg:text-8xl mt-6 leading-none" data-testid="christmas-coming-soon-title">
      COMING SOON
    </p>
    <ChristmasCountdown />
    <ChristmasCutoffs />
    <p className="mt-5 max-w-lg mx-auto text-base sm:text-lg text-white/95">
      Festive decorations, stocking fillers and personalised gifts are on the printer. Check back soon!
    </p>
    <button data-testid="christmas-custom-btn" onClick={() => scrollToId("custom")}
      className="mt-8 press chunk-sm rounded-full bg-[var(--yellow)] text-[var(--ink)] px-6 py-3 font-bold">
      Want something festive now? Ask for a custom print
    </button>
  </div>
);
